import { render, staticRenderFns } from "./integralPaymentStatus.vue?vue&type=template&id=36c8f01e"
import script from "./integralPaymentStatus.vue?vue&type=script&lang=js"
export * from "./integralPaymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports